<template>
	<div class="map-container"></div>
</template>

<script>
	export default {
		props: {
			latitude: {
				type: Number,
				default: 55.01657628017477
			},
			longitude: {
				type: Number,
				default: -7.309233337402361
			}
		},

		data() {
			return {
				lat: this.latitude,
				lng: this.longitude,
			}
		},

		mounted() {
			// Set coordinates
			let self = this;
			let myLatlng = new google.maps.LatLng(this.lat, this.lng);

			// Options
			let mapOptions = {
				zoom: 13,
				center: myLatlng
			};

			// Apply options
			let map = new google.maps.Map(this.$el, mapOptions);

			// Add marker
			let marker = new google.maps.Marker({
				position: myLatlng,
				map: map
			});

			marker.setMap(map);
			let locationButton = document.createElement("button");
			locationButton.textContent = "ចាប់ទីតាំងបច្ចប្បន្ន";
			locationButton.classList.add("custom-map-control-button");
			map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);
			locationButton.addEventListener("click", () => {
				// Try HTML5 geolocation.
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							const pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude,
							};
							map.setZoom(18);
							// infoWindow.setPosition(pos);
							// infoWindow.setContent("Location found.");
							// infoWindow.open(map);
							map.setCenter(pos);
						},
						() => {
							// handleLocationError(true, infoWindow, map.getCenter());
						}
					);
				} else {
					// Browser doesn't support Geolocation
					// handleLocationError(false, infoWindow, map.getCenter());
				}
			});



			google.maps.event.addListener(map, "center_changed", function () {
				let lat = map.getCenter().lat();
				let lon = map.getCenter().lng();
				let newLatLng = { lat: lat, lng: lon };
				marker.setPosition(newLatLng);

				self.$emit('locationUpdated', newLatLng)
			});
		}
	}
</script>
<style>
	.custom-map-control-button {
		background-color: #fff;
		border: 0;
		border-radius: 2px;
		box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
		margin: 10px;
		padding: 0 0.5em;
		font: 400 18px Roboto, Arial, sans-serif;
		overflow: hidden;
		height: 40px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMaps.vue